<div class="client-service-regions">
  <div class="action-row justify-end client-service-regions__head">
    <button type="button" class="btn btn-outline btn-sm" (click)="addEdit()">
      <i class="bi bi-plus-lg me-1"></i>
      Add office
    </button>
  </div>

  <div class="client-service-regions__grid">
    <app-company-offices-grid
      [gridName]="'ClientOffices'"
      [suppliedQueryData]="suppliedGridQuery"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      [(reloadGridData)]="reloadGrid"
      (actionEvent)="action($event)"
    ></app-company-offices-grid>
  </div>
</div>
